module.exports = __webpack_public_path__ + "img/frame (275).57360a40.jpg";